import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'MESSAGE' });



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/handlers.js